import { Instance } from 'mobx-state-tree';
import { ProjectUnscheduledStopsBulkUpdatedDtoModelBase } from './ProjectUnscheduledStopsBulkUpdatedDtoModel.base';

/* The TypeScript type of an instance of ProjectUnscheduledStopsBulkUpdatedDtoModel */
export interface ProjectUnscheduledStopsBulkUpdatedDtoModelType extends Instance<typeof ProjectUnscheduledStopsBulkUpdatedDtoModel.Type> {}

/* A graphql query fragment builders for ProjectUnscheduledStopsBulkUpdatedDtoModel */
export {
  selectFromProjectUnscheduledStopsBulkUpdatedDto,
  projectUnscheduledStopsBulkUpdatedDtoModelPrimitives,
  ProjectUnscheduledStopsBulkUpdatedDtoModelSelector,
} from './ProjectUnscheduledStopsBulkUpdatedDtoModel.base';

/**
 * ProjectUnscheduledStopsBulkUpdatedDtoModel
 *
 * Unscheduled stops bulk edited
 */
export const ProjectUnscheduledStopsBulkUpdatedDtoModel = ProjectUnscheduledStopsBulkUpdatedDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
